import { Button, Snackbar, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import MuiAlert from "@material-ui/lab/Alert";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deleteBoatType,
	getBoatTypes,
	updateBoatType,
} from "../../../../api/boattype";
import { FRONT_URL } from "../../../../utils";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
	booleanFormatter,
	buttonsStyle,
} from "../../../components/tables/table";

function getData(boatTypes) {
	let data = [];
	for (let i = 0; i < boatTypes.length; ++i) {
		const elem = {};
		elem.name = boatTypes[i].fullName;
		elem.createdAt = boatTypes[i].createdAt;
		elem.default = boatTypes[i].default;
		elem.data = boatTypes[i];
		elem.id = boatTypes[i]._id;
		data = data.concat(elem);
	}
	return data;
}

export default function BoatTypesPage() {
	const [data, setData] = useState([]);
	const [boatTypeId, setBoatTypeId] = useState(null);
	const [selectedBoatType, setSelectedBoatType] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const [copiedLink, setCopiedLink] = useState(false);
	const history = useHistory();

	function buttonFormatter(cell) {
		const boatType = cell;

		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/edit-boatType/" + cell._id)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Delete">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setBoatTypeId(cell._id);
							setOpenConfirmDialog(2);
						}}
					>
						<DeleteIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	function defaultFormatter(cell) {
		return cell ? <div className="default-label">default</div> : "";
	}

	const columns = [
		{ dataField: "name", text: "Full name", sort: true },
		{
			dataField: "data",
			text: "",
			formatter: buttonFormatter,
			align: "end",
  			style: {  whiteSpace: "nowrap" },
		},
	];

	useEffect(() => {
		getBoatTypes()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get boatTypes.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="BoatTypes list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-boatType")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={"Are you sure you want to remove this boatType?"}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteBoatType(boatTypeId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"BoatType removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: "Could not remove boatType.",
									});
								});
						}}
					/>
					<ConfirmDialog
						title={`Are you sure you want to ${
							selectedBoatType?.active ? "end" : "start"
						} this boatType?`}
						open={openConfirmDialog === 4}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							updateBoatType(selectedBoatType._id, {
								...selectedBoatType,
								active: !selectedBoatType?.active,
							})
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: "Success!",
											customMessage: !selectedBoatType?.active
												? "BoatType Started"
												: "BoatType Ended",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not update the boatType.",
									});
								});
						}}
					></ConfirmDialog>
				</CardBody>
			</Card>
			<Snackbar
				open={copiedLink}
				autoHideDuration={6000}
				onClose={() => setCopiedLink(false)}
			>
				<MuiAlert severity="info" sx={{ width: "100%" }}>
					BoatType link copied
				</MuiAlert>
			</Snackbar>
		</>
	);
}
